/* Dollpins · carrito lateral, cajón de deseos, aviso al añadir y animación del pin volando al carrito.
   Usa la API de carrito de Shopify. El pago es el checkout de Shopify (/checkout): no se toca la pasarela. */
(function () {
  var root = document.querySelector('[data-dp-drawers]');
  if (!root) return;
  var cfg;
  try { cfg = JSON.parse(root.querySelector('[data-dp-drawers-cfg]').textContent); } catch (e) { return; }

  var cartEl = root.querySelector('[data-dp-cartdrawer]');
  var wishEl = root.querySelector('[data-dp-wishdrawer]');
  var toasts = root.querySelector('[data-dp-toasts]');
  var cartBody = root.querySelector('[data-dp-cart-body]');
  var cartFoot = root.querySelector('[data-dp-cart-foot]');
  var cartTotal = root.querySelector('[data-dp-cart-total]');
  var notice = root.querySelector('[data-dp-cart-notice]');
  var wishBody = root.querySelector('[data-dp-wish-body]');
  var wishFoot = root.querySelector('[data-dp-wish-foot]');
  var wishTotal = root.querySelector('[data-dp-wish-total]');
  var cart = null;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function money(cents) { return '$' + Math.round(cents / 100).toLocaleString('es-CO'); }
  function sized(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function titleCase(t) { t = String(t || ''); return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase(); }
  function api(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
  }

  /* ---------- abrir / cerrar ---------- */
  function lock(on) { document.documentElement.classList.toggle('dp-lock', on); }
  function closeAll() { cartEl.hidden = true; wishEl.hidden = true; lock(false); }
  function show(drawer) {
    clearToasts();
    cartEl.hidden = drawer !== cartEl; wishEl.hidden = drawer !== wishEl;
    lock(true);
    var p = drawer.querySelector('.dp-drawer__panel');
    if (p) { p.setAttribute('tabindex', '-1'); p.focus({ preventScroll: true }); }
  }
  function openCart() {
    show(cartEl);
    showNotice('');
    return refresh();
  }
  function openWish() { show(wishEl); renderWish(); }

  [cartEl, wishEl].forEach(function (d) {
    d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-dp-close]')) closeAll(); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && (!cartEl.hidden || !wishEl.hidden)) closeAll(); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-icon-bubble');
    if (a) { e.preventDefault(); openCart(); }
  });
  document.addEventListener('dp:wish-open', openWish);

  function showNotice(msg) {
    notice.textContent = msg || '';
    notice.hidden = !msg;
  }

  /* ---------- carrito ---------- */
  function refresh() {
    return api(cfg.cartUrl + '.js').then(function (res) {
      cart = res.json; renderCart();
      return cart;
    });
  }

  function refreshIcon() {
    return fetch(cfg.root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['cart-icon-bubble'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.shopify-section') || doc.body;
        var a = document.getElementById('cart-icon-bubble');
        if (a) a.innerHTML = inner.innerHTML;
      }).catch(function () {});
  }

  function renderCart() {
    cartBody.innerHTML = '';
    if (!cart || !cart.items.length) {
      cartBody.appendChild(el('div', 'dp-drawer__empty', 'Tu carrito está vacío. Ve por unos pines.'));
      cartFoot.hidden = true;
      return;
    }
    cart.items.forEach(function (it) {
      var row = el('div', 'dp-ci');
      var a = el('a', 'dp-ci__img'); a.href = it.url;
      if (it.image) { var im = el('img'); im.src = sized(it.image, 160); im.alt = it.product_title; im.width = 54; im.height = 54; a.appendChild(im); }
      row.appendChild(a);
      var txt = el('div', 'dp-ci__txt');
      var name = el('a', 'dp-ci__name', titleCase(it.product_title)); name.href = it.url;
      txt.appendChild(name);
      var meta = [];
      if (it.variant_title && it.variant_title !== 'Default Title') meta.push(it.variant_title);
      meta.push(money(it.final_price));
      txt.appendChild(el('div', 'dp-ci__meta', meta.join(' · ')));
      row.appendChild(txt);
      var q = el('div', 'dp-ci__qty');
      var dec = el('button', 'dp-ci__btn', '−'); dec.type = 'button'; dec.setAttribute('aria-label', 'Quitar uno');
      var inc = el('button', 'dp-ci__btn', '+'); inc.type = 'button'; inc.setAttribute('aria-label', 'Añadir uno');
      q.appendChild(dec); q.appendChild(el('div', 'dp-ci__n', String(it.quantity))); q.appendChild(inc);
      row.appendChild(q);
      dec.addEventListener('click', function () { change(it.key, it.quantity - 1); });
      inc.addEventListener('click', function () { change(it.key, it.quantity + 1); });
      cartBody.appendChild(row);
    });
    cartTotal.textContent = money(cart.total_price) + ' ' + cart.currency;
    cartFoot.hidden = false;
  }

  function change(key, qty) {
    showNotice('');
    api(cfg.cartChangeUrl + '.js', { id: key, quantity: qty }).then(function (res) {
      if (!res.ok) {
        showNotice(res.json.description || res.json.message || 'No se pudo cambiar la cantidad');
        return refresh();
      }
      cart = res.json; renderCart(); refreshIcon();
    });
  }

  /* ---------- añadir ---------- */
  function addItems(items, ctx) {
    ctx = ctx || {};
    return api(cfg.cartAddUrl + '.js', { items: items }).then(function (res) {
      if (!res.ok) {
        var msg = res.json.description || res.json.message || 'No se pudo añadir al carrito';
        toast({ title: 'Ups', sub: msg, error: true });
        throw new Error(msg);
      }
      return refresh().then(function () {
        refreshIcon();
        if (ctx.from) { try { fly(ctx.from, ctx.img); } catch (e) {} }
        if (!ctx.silent) addedToast();
        return cart;
      });
    });
  }

  function fly(from, imgEl) {
    var target = document.getElementById('cart-icon-bubble');
    if (!target || !imgEl) return;
    var r = imgEl.getBoundingClientRect(), c = target.getBoundingClientRect();
    if (!r.width) return;
    var node = document.createElement('img');
    node.src = imgEl.currentSrc || imgEl.src;
    var w = Math.min(120, Math.max(60, r.width * 0.6));
    node.style.cssText = 'position:fixed;left:' + (r.left + r.width / 2 - w / 2) + 'px;top:' + (r.top + r.height / 2 - w / 2) + 'px;width:' + w + 'px;height:' + w + 'px;object-fit:cover;border-radius:50%;border:3px solid #141312;z-index:300;pointer-events:none;filter:drop-shadow(4px 6px 6px rgba(20,19,18,.35))';
    document.body.appendChild(node);
    var dx = c.left + c.width / 2 - (r.left + r.width / 2), dy = c.top + c.height / 2 - (r.top + r.height / 2);
    var anim = node.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)' },
      { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - 120) + 'px) scale(.8) rotate(-20deg)', offset: 0.45 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.18) rotate(20deg)', opacity: 0.6 }
    ], { duration: 750, easing: 'cubic-bezier(.45,0,.2,1)' });
    anim.onfinish = function () {
      node.remove();
      target.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.28) rotate(-6deg)' }, { transform: 'scale(.95) rotate(3deg)' }, { transform: 'scale(1)' }], { duration: 450, easing: 'ease-out' });
    };
  }

  /* ---------- avisos ---------- */
  var MSGS = [
    ['¿De verdad es para mí?', 'Prometo cuidarlo con mi vida.'], ['Gracias, de corazón', 'Este pin ya tiene casa.'],
    ['¡Paz y pines!', 'Uno más a la colección ✌'], ['Qué estilo, eh', 'Ese pin te va a quedar de lujo.'],
    ['Pedido registrado', 'Ya lo anoté en el sistema, humano.'], ['Te lo hago con amor', 'Lo empaco yo mismo 💗'],
    ['Te traje flores', 'Por tu excelente gusto.'], ['¡Tú! Sí, tú', 'Acabas de elegir muy bien.'],
    ['Bleh, ¡me encanta!', 'Tu carrito se ve delicioso.'], ['Me derrito', 'Demasiado lindo para mí.'],
    ['Amor a primer pin', 'Ustedes dos nacieron juntos.'], ['¡Sorpresa!', 'Mira lo que agregaste 🙌'],
    ['Aprobado', 'El comité de ratones dice que sí 👍'], ['¡Ven acá, pin!', 'Ya casi es tuyo, ya casi.']
  ];
  var msgIdx = Math.floor(Math.random() * MSGS.length);
  var toastTimer;

  function clearToasts() { toasts.innerHTML = ''; clearTimeout(toastTimer); }
  function toast(o) {
    clearToasts();
    var t = el('div', 'dp-toast' + (o.error ? ' is-error' : ''));
    if (o.img) { var im = el('img'); im.src = o.img; im.alt = ''; t.appendChild(im); }
    var d = el('div');
    d.appendChild(el('div', 'dp-toast__t', o.title));
    d.appendChild(el('div', 'dp-toast__s', o.sub));
    t.appendChild(d);
    if (!o.error) {
      var b = el('button', 'dp-toast__go', 'Carrito →'); b.type = 'button';
      b.addEventListener('click', function () { clearToasts(); openCart(); });
      t.appendChild(b);
    }
    toasts.appendChild(t);
    toastTimer = setTimeout(clearToasts, o.error ? 4200 : 2400);
  }
  function addedToast() {
    msgIdx = (msgIdx + 1) % MSGS.length;
    toast({ title: MSGS[msgIdx][0], sub: MSGS[msgIdx][1], img: cfg.msg.replace('dp-msg-1.webp', 'dp-msg-' + (msgIdx + 1) + '.webp') });
  }
  function wishToast() {
    clearToasts();
    var b = el('button', 'dp-wtoast'); b.type = 'button';
    var im = el('img'); im.src = cfg.mouse; im.alt = ''; im.width = 32; im.height = 32;
    b.appendChild(im);
    b.appendChild(document.createTextNode('Guardado en tu lista de deseos ♥'));
    b.appendChild(el('span', null, 'Ver lista →'));
    b.addEventListener('click', function () { clearToasts(); openWish(); });
    toasts.appendChild(b);
    toastTimer = setTimeout(clearToasts, 2600);
  }

  /* ---------- botones «+» de las tarjetas ---------- */
  function findImg(btn) {
    var scope = btn.closest('.dp-card, .dp-pcard, .dp-quiz__res, [data-dp-prod]');
    return scope && (scope.querySelector('img.dp-card__photo, .dp-quiz__pin img, img[data-dp-fly]'));
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dp-add]');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    var id = Number(btn.getAttribute('data-dp-add'));
    if (!id) return;
    btn.classList.add('is-loading');
    addItems([{ id: id, quantity: Number(btn.getAttribute('data-qty')) || 1 }], { from: btn, img: findImg(btn) })
      .catch(function () {})
      .then(function () { btn.classList.remove('is-loading'); });
  });

  /* ---------- lista de deseos ---------- */
  var pcache = {};
  /* Devuelve el producto; {gone:true} solo si Shopify dice 404; null si falló la red (se reintenta una vez). */
  function loadProduct(handle, retry) {
    if (!pcache[handle]) {
      pcache[handle] = fetch(cfg.productsUrl + encodeURIComponent(handle) + '.js')
        .then(function (r) {
          if (r.status === 404) return { gone: true };
          if (!r.ok) throw new Error('http ' + r.status);
          return r.json();
        })
        .catch(function () {
          delete pcache[handle];
          if (retry === false) return null;
          return new Promise(function (res) { setTimeout(res, 700); }).then(function () { return loadProduct(handle, false); });
        });
    }
    return pcache[handle];
  }

  function firstAvailable(p) {
    return p.variants.filter(function (v) { return v.available; })[0];
  }

  var wishRun = 0;
  function renderWish() {
    var run = ++wishRun;
    var list = window.DPWish ? window.DPWish.list() : [];
    wishTotal.textContent = list.length;
    if (!list.length) {
      wishBody.innerHTML = '';
      var empty = el('div', 'dp-wempty');
      var im = el('img'); im.src = cfg.mouse; im.alt = ''; im.width = 90; im.height = 90;
      empty.appendChild(im);
      empty.appendChild(el('div', 'dp-wempty__t', 'Aún no hay deseos'));
      empty.appendChild(el('div', 'dp-wempty__s', 'Toca el ♥ en cualquier pin y el ratón te lo guarda aquí.'));
      wishBody.appendChild(empty);
      wishFoot.hidden = true;
      return;
    }
    Promise.all(list.map(loadProduct)).then(function (ps) {
      if (run !== wishRun) return;
      wishBody.innerHTML = '';
      var buyable = 0, missing = [];
      ps.forEach(function (p, i) {
        if (p && p.gone) { missing.push(list[i]); return; }
        if (!p) {
          /* no se pudo cargar: se conserva en la lista y se ofrece el enlace */
          var fb = el('div', 'dp-w');
          var ft = el('div', 'dp-w__top');
          var ftx = el('div', 'dp-w__txt');
          var fl = el('a', 'dp-w__name', list[i].replace(/-/g, ' ')); fl.href = cfg.productsUrl + list[i];
          ftx.appendChild(fl);
          ftx.appendChild(el('div', 'dp-w__note', 'No se pudo cargar ahora'));
          ft.appendChild(ftx);
          var frm = el('button', 'dp-w__rm', '×'); frm.type = 'button'; frm.setAttribute('aria-label', 'Quitar de la lista');
          frm.addEventListener('click', function () { window.DPWish.remove(list[i]); });
          ft.appendChild(frm);
          fb.appendChild(ft);
          wishBody.appendChild(fb);
          return;
        }
        var out = !p.available;
        var card = el('div', 'dp-w');
        var top = el('div', 'dp-w__top');
        var thumb = el('a', 'dp-w__img'); thumb.href = p.url;
        if (p.featured_image) { var ti = el('img'); ti.src = sized(p.featured_image, 180); ti.alt = ''; ti.width = 70; ti.height = 70; if (out) ti.style.opacity = '.45'; thumb.appendChild(ti); }
        top.appendChild(thumb);
        var txt = el('div', 'dp-w__txt');
        var nm = el('a', 'dp-w__name', titleCase(p.title)); nm.href = p.url;
        txt.appendChild(nm);
        txt.appendChild(el('div', 'dp-w__price', money(p.price)));
        var note = el('div', 'dp-w__note' + (out ? '' : ' is-ok'), out ? 'Agotado por ahora' : 'Disponible');
        txt.appendChild(note);
        top.appendChild(txt);
        var rm = el('button', 'dp-w__rm', '×'); rm.type = 'button'; rm.title = 'Quitar de la lista'; rm.setAttribute('aria-label', 'Quitar de la lista');
        rm.addEventListener('click', function () { window.DPWish.remove(list[i]); });
        top.appendChild(rm);
        card.appendChild(top);

        var acts = el('div', 'dp-w__acts');
        if (out) {
          var so = el('span', 'dp-w__add is-out', 'Agotado'); acts.appendChild(so);
        } else if (p.variants.length === 1) {
          buyable++;
          var add = el('button', 'dp-w__add'); add.type = 'button';
          add.textContent = 'Agregar al carrito';
          add.addEventListener('click', function () {
            add.disabled = true;
            addItems([{ id: p.variants[0].id, quantity: 1 }], { from: add, img: thumb.querySelector('img') }).catch(function () {}).then(function () { add.disabled = false; });
          });
          acts.appendChild(add);
        } else {
          var opt = el('a', 'dp-w__add', 'Elegir opciones'); opt.href = p.url; acts.appendChild(opt);
        }
        var view = el('a', 'dp-w__view', 'Ver pin'); view.href = p.url;
        acts.appendChild(view);
        card.appendChild(acts);
        wishBody.appendChild(card);
      });
      wishFoot.hidden = false;
      wishFoot.querySelector('[data-dp-wish-all]').hidden = buyable === 0;
      if (missing.length) missing.forEach(function (h) { window.DPWish.remove(h); });
    });
  }

  var wishAll = root.querySelector('[data-dp-wish-all]');
  wishAll.addEventListener('click', function () {
    var list = window.DPWish.list();
    wishAll.disabled = true;
    Promise.all(list.map(loadProduct)).then(function (ps) {
      var items = ps.filter(function (p) { return p && !p.gone && p.available && p.variants.length === 1; })
        .map(function (p) { return { id: p.variants[0].id, quantity: 1 }; });
      if (!items.length) return;
      return addItems(items, { from: wishAll, img: wishBody.querySelector('img') });
    }).catch(function () {}).then(function () { wishAll.disabled = false; });
  });

  var lastWish = window.DPWish ? window.DPWish.list().length : 0;
  document.addEventListener('dp:wish-change', function (e) {
    var n = (e.detail || []).length;
    if (n > lastWish && wishEl.hidden) wishToast();
    lastWish = n;
    if (!wishEl.hidden) renderWish();
  });

  window.DPCart = { add: addItems, open: openCart, close: closeAll, refresh: refresh, toastAdded: addedToast };
})();
